import React, { useEffect, useState } from "react";

import { Auth } from "aws-amplify";

import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";

import { useAdmin } from "providers/AdminProvider/AdminProvider";

import logout from "api/logout";

import Loader from "components/Loader/Loader";
import Button from "react-bootstrap/cjs/Button";
import Navigation from "navigation/Navigation";

import classes from "./Dashboard.module.css";
import Sticky from "react-sticky-el";
import Alert from "react-bootstrap/cjs/Alert";
import logo from "images/ilx-logo.webp";
import LogoutModal from "modals/LogoutModal/LogoutModal";
import HelpModal from "modals/Help/HelpModal";

const Dashboard = ({ children }) => {
  const location = useLocation();
  const history = useHistory();

  const helpRoute = useRouteMatch({
    path: "/help",
  });

  const { state, setUser, setToken } = useAdmin();
  const { user } = state || { token: "", user: { username: "" } };
  const { username } = user || { username: "" };

  const [showLogout, setShowLogout] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const [preHelpPath, setPreHelpPath] = useState({ pathname: "/" });
  const [helpPath, setHelpPath] = useState({ pathname: "/help" });

  const [showHelp, setShowHelp] = useState(!!helpRoute);

  useEffect(() => {
    setShowHelp(!!helpRoute);
  }, [helpRoute]);

  if (loggingOut) return <Loader />;

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await Auth.signOut();
    } catch (e) {
      console.error("[AWS error signing out]", e);
    } finally {
      try {
        await logout();
      } catch (e) {
        console.error("[ILX error logging out]");
      } finally {
        setUser({});
        setToken(false);
      }
    }
  };

  const openHelp = () => {
    setPreHelpPath(location);
    history.replace(helpPath);
  };

  const closeHelp = () => {
    setHelpPath(location);
    history.replace(preHelpPath);
  };

  return (
    <>
      {process.env.NODE_ENV === "development" && process.env.REACT_APP_ILX_LIVE_DATA && (
        <Sticky stickyStyle={{ zIndex: 9999 }}>
          <Alert variant={"danger"} style={{ zIndex: 9999 }}>
            <Alert.Heading className={classes.blink}>
              <strong>Production Data</strong>
            </Alert.Heading>
            <p>Unless you're debugging an issue specific to live, please stop and switch to UAT.</p>
          </Alert>
        </Sticky>
      )}
      <div className={classes.Dashboard}>
        <header>
          <img src={logo} alt={"ILX Admin"} width={86} />
          <div>
            <p>
              Logged in as: <Link to={"/administrator"}>{username ? username : ""}</Link>
            </p>
            <div className={classes.ButtonContainer}>
              <Button variant={"info"} className={"mr-sm-2"} onClick={openHelp}>
                Help
              </Button>
              <Button variant={"warning"} onClick={() => setShowLogout(true)}>
                Logout
              </Button>
            </div>
          </div>
        </header>
        <main className={classes.Panel}>
          <Navigation />
          <div className={classes.Body}>{children}</div>
        </main>
      </div>
      <LogoutModal
        show={showLogout}
        onHide={() => setShowLogout(false)}
        handleLogout={handleLogout}
      />
      <HelpModal show={showHelp} onHide={closeHelp} />
    </>
  );
};

export default Dashboard;
